import { useMediaQuery } from 'react-responsive'

export interface Widths {
    bigScreen: number
    laptopMaxWidth: number
    mobileLandscape: number
    tabletMaxWidth: number
    tabletMinWidthLandscape: number
    tabletMinWidthPortrait: number
}

const widths: Widths = {
    bigScreen: 1824,
    laptopMaxWidth: 1280,
    mobileLandscape: 480,
    tabletMaxWidth: 1024,
    tabletMinWidthLandscape: 992,
    tabletMinWidthPortrait: 768
}

export const useMediaQueries = () => {
    const isDesktop = useMediaQuery({
        query: `(min-width: ${widths.tabletMaxWidth + 1}px)`
    })
    const isLaptop = useMediaQuery({
        query: `(min-width: ${widths.tabletMaxWidth + 1}px) and (max-width: ${
            widths.laptopMaxWidth
        }px)`
    })
    const isTabletLandscapeAtLeast = useMediaQuery({
        query: `(min-width: ${widths.tabletMinWidthLandscape}px)`
    })
    const isTabletLandscape = useMediaQuery({
        query: `(min-width: ${widths.tabletMinWidthLandscape}px) and (max-width: ${widths.tabletMaxWidth}px)`
    })
    const isTabletPortrait = useMediaQuery({
        query: `(min-width: ${widths.tabletMinWidthPortrait}px) and (max-width: ${widths.tabletMaxWidth}px)`
    })
    const isMobileLandscape = useMediaQuery({
        query: `(min-width: ${widths.mobileLandscape + 1}px) and (max-width: ${
            widths.tabletMinWidthPortrait - 1
        }px)`
    })
    const isMobilePortrait = useMediaQuery({
        query: `(max-width: ${widths.mobileLandscape}px)`
    })
    const isDesktopOrLaptop = isDesktop && isLaptop
    const isTablet = isTabletPortrait || isTabletLandscape
    const isMobile = isMobilePortrait || isMobileLandscape
    const isBigScreen = useMediaQuery({
        query: `(min-device-width: ${widths.bigScreen}px)`
    })
    const isLandscape = useMediaQuery({ query: `(orientation: landscape)` })
    const isPortrait = useMediaQuery({ query: `(orientation: portrait)` })
    const isRetina = useMediaQuery({ query: `(min-resolution: 2dppx)` })

    return {
        isBigScreen,
        isDesktop,
        isDesktopOrLaptop,
        isLandscape,
        isLaptop,
        isMobile,
        isMobileLandscape,
        isMobilePortrait,
        isPortrait,
        isRetina,
        isTablet,
        isTabletLandscape,
        isTabletLandscapeAtLeast,
        isTabletPortrait
    }
}
